import React from 'react'


function Loader() {
    return (
        <div width="300px"> <center><img  width="300px" className="img" src="icons/loader.gif"/></center>
            
        </div>
    )
}

export default Loader
